<app-sidebar></app-sidebar>

<div style="position: relative; left: 10px; top: 10px;">
  <div>
    <a (click)="deleteAccess()">تسجيل الخروج</a>
  </div>
</div>

<div class="vincent_container vincent_typography">
  <div class="row gutters">
    <div class="col col-10 vincent_content">
      <table class="vincent_cart">
        <thead>
          <tr>
            <th></th>
            <th><span>البريد الألكتروني</span></th>
            <th><span>Id</span></th>
          </tr>
        </thead>
        <tbody>
          <tr class="vincent_cart_item" *ngFor="let info of users; index as i" style="border-bottom: none;">

            <td>
              <a class="vincent_button" (click)="basicModal2.show()">حذف المستخدم</a>
            </td>
            <td>
              {{info.email}}
            </td>
            <td class="vincent_product-subtotal">
              {{info.id}}
            </td>
               <!-- confirm delete model-->
               <div style="overflow-y: scroll" mdbModal #basicModal2="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal2.hide()">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <img src="assets/imgs/trash.png" style="width:50px; height: 50px; margin-bottom: 10px;">
                      <p>هل تريد تأكيد الحذف؟</p>
                    </div>
                    <div class="modal-footer">
                      <button type="button" mdbBtn color="secondary" class="waves-light" (click)="deleteUser(info.id)" mdbWavesEffect>تأكيد</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- confirm delete model end--> 
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>